<template>
  <router-link
    id="explore-all-nav"
    :active-class="!selectedListName ? 'router-link-active' : 'router-link-inactive'"
    class="d-flex align-items-center explore-all-link"
    :class="{
      'radial-hover d-block text-truncate': true
    }"
    :to="getExploreAllPageLocation()"
  >
    <i class="explore-icon mr-2"></i>
    Explore all
  </router-link>
</template>

<script>
import EventBusMixin from '@/mixins/EventBusMixin'
import UserListsMixin from '@/mixins/UserListsMixin'
import { getExploreAllPageLocation } from '@/utils/navigationConfigs'

/**
 * This give the link to be shown in sidebar,click of which will take user to "Explore All" page
 */
export default {
  name: 'ExploreAllLink',
  props: ['orgId', 'subOrgId'],
  mixins: [UserListsMixin, EventBusMixin],
  data() {
    return {}
  },
  computed: {},
  methods: {
    getExploreAllPageLocation() {
      return getExploreAllPageLocation({
        orgId: this.orgId,
        subOrgId: this.subOrgId
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>
